import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

const ACTIVATION_ID_PATTERN = /^[1-9][0-9]*-[1-9][0-9]*$/
const ACCEPTED_KINDS = new Set([ "tab-return", "foreground" ])

export default class extends BridgeComponent {
  connect() {
    super.connect()
    const generation = crypto.randomUUID()
    this.connectionGeneration = generation
    this.send("connect", { generation }, (message) => this.receiveActivation(message, generation))
  }

  disconnect() {
    const generation = this.connectionGeneration
    super.disconnect()
    this.connectionGeneration = null
    if (generation) this.send("disconnect", { generation })
  }

  receiveActivation(message, generation) {
    if (generation !== this.connectionGeneration) return

    const kind = message?.data?.kind
    const id = message?.data?.id
    if (!ACCEPTED_KINDS.has(kind) || !ACTIVATION_ID_PATTERN.test(id)) return

    let acknowledged = false
    const acknowledge = () => {
      if (acknowledged || generation !== this.connectionGeneration) return
      acknowledged = true
      this.send("acknowledge", { generation, id })
    }
    this.dispatch("activate", { detail: { kind, id, acknowledge } })
  }
}
